import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
  },
  listOfAnkets: {
    flexGrow: 1,
  },
}));

export default useStyles;
